'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _reactFlexboxGrid = require('react-flexbox-grid');

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _components = require('../../components');

var _IssuePage = require('./IssuePage.css');

var _IssuePage2 = _interopRequireDefault(_IssuePage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IssueDeforestation = (_dec = (0, _reactCssModules2.default)(_IssuePage2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(IssueDeforestation, _Component);

  function IssueDeforestation(props) {
    (0, _classCallCheck3.default)(this, IssueDeforestation);

    var _this = (0, _possibleConstructorReturn3.default)(this, (IssueDeforestation.__proto__ || (0, _getPrototypeOf2.default)(IssueDeforestation)).call(this, props));

    _this.state = {
      title: 'The issue: Deforestation',
      description: 'Clearing rain forests for cattle grazing or palm oil production contributes to the climate crisis and threatens the rights of Indigenous peoples, traditional landowners, and local communities.',
      url: _config2.default.domain + _config2.default.routes.issueDeforestation
    };
    return _this;
  }

  (0, _createClass3.default)(IssueDeforestation, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { styleName: 'page issue-dff' },
        _container2.default.helmet(this.state.title, this.state.description, this.state.url),
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(
            'section',
            { styleName: 'section' },
            _react2.default.createElement(
              'h1',
              { styleName: 'issue-top-label' },
              'The issue: ',
              _react2.default.createElement(
                'span',
                null,
                'Deforestation'
              )
            ),
            _react2.default.createElement(
              'h2',
              { styleName: 'issue-top-headline' },
              'The destruction of forests is a disaster for climate, biodiversity, and human rights'
            ),
            _react2.default.createElement(
              'h3',
              { styleName: 'issue-top-copy' },
              'Clearing rain forests for cattle grazing or palm oil production contributes to the climate crisis and threatens the rights of Indigenous peoples, traditional landowners, and local communities.'
            )
          ),
          _react2.default.createElement(
            'section',
            { styleName: 'section' },
            _react2.default.createElement(
              _reactFlexboxGrid.Row,
              null,
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 12, md: 4 },
                _react2.default.createElement(
                  'div',
                  { styleName: 'issue-second-headline' },
                  _react2.default.createElement(
                    'span',
                    { style: { whiteSpace: 'nowrap' } },
                    '\u2014\u2014\u2014\u2014'
                  ),
                  _react2.default.createElement('br', null),
                  _react2.default.createElement(
                    'h2',
                    null,
                    'Retirement plans are invested in deforestation'
                  )
                )
              ),
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 12, md: 8 },
                _react2.default.createElement(
                  'div',
                  { styleName: 'issue-second-copy' },
                  _react2.default.createElement(
                    'p',
                    null,
                    'From the Amazon to Borneo to the boreal forests of Northern Alberta, asset managers consistently invest in industries that are cutting and burning down our rainforests. This releases carbon, removes carbon sinks, and threatens endangered plants and animal species with extinction.'
                  ),
                  _react2.default.createElement(
                    'p',
                    null,
                    'Through displacement, land grabs, and violence, the agribusiness industry driving this deforestation also threatens the rights of Indigenous peoples and local communities who oppose deforestation.'
                  ),
                  _react2.default.createElement(
                    'p',
                    null,
                    'Through funds from asset managers like Vanguard, BlackRock, and State Street, corporate retirement plans have hundreds of millions of dollars invested in agricultural commodity producers and traders that have a past record or a significant risk of contributing to deforestation, land grabbing, and human rights abuses.'
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'section',
            { styleName: 'section' },
            _react2.default.createElement(
              _reactFlexboxGrid.Row,
              null,
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 12, md: 6 },
                _react2.default.createElement('div', { styleName: 'img-issue' })
              ),
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 12, md: 6 },
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'h2',
                    { styleName: 'issue-focus-label' },
                    'FOCUS: SUSTAINABILITY RISK'
                  ),
                  _react2.default.createElement(
                    'h3',
                    { styleName: 'issue-focus-headline' },
                    'Agricultural commodity producers and traders'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'issue-focus-copy' },
                    _react2.default.createElement(
                      'p',
                      null,
                      'Companies that produce and trade palm oil, paper/pulp, rubber, timber, cattle, and soy have a high risk of deforestation being tied to their supply chains.'
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      'Different industries impact different forests. For example, deforestation in the Amazon often begins with land speculators illegally clearing and burning large areas of forests and then selling this land to ranchers for the production of beef and soy, which is then sold to Archer-Daniels Midland, JBS, and other global traders.'
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.routes.companies + '#deforestation',
                          title: 'Companies: Deforestation',
                          xstrong: true
                        },
                        'Learn more',
                        _react2.default.createElement(_components.LinkIcon, null)
                      )
                    )
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'section-solutions-faq-background' },
          _react2.default.createElement(
            _components.ContainerDivs,
            null,
            _react2.default.createElement(
              'section',
              { styleName: 'section section-solutions-faq' },
              _react2.default.createElement(
                _reactFlexboxGrid.Row,
                null,
                _react2.default.createElement(
                  _reactFlexboxGrid.Col,
                  { xs: 12, md: 6 },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'section-solutions-faq-cell' },
                    _react2.default.createElement(
                      'h2',
                      { styleName: 'issue-solutions-label' },
                      'The Solutions'
                    ),
                    _react2.default.createElement(
                      'h3',
                      { styleName: 'issue-solutions-headline' },
                      'Exclude deforestation-driving companies from retirement plan default options'
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'issue-solutions-copy' },
                      _react2.default.createElement(
                        'p',
                        null,
                        'The default option offered in company retirement plans, which usually ends up with the bulk of employee contributions, should be sustainably invested and exclude deforestation commodity companies if they lack clear policies with safeguards in place to ensure that their products are not being sourced from deforested lands.'
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'issue-faqs-link' },
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.routes.solutionDefaultSustainability,
                          title: 'Solution: Default to sustainability',
                          xstrong: true
                        },
                        'Explore solutions',
                        _react2.default.createElement(_components.LinkIcon, null)
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  _reactFlexboxGrid.Col,
                  { xs: 12, md: 6 },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'section-solutions-faq-cell' },
                    _react2.default.createElement(
                      'h2',
                      { styleName: 'issue-faqs-label' },
                      'FAQs'
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'issue-faqs-headline' },
                      'Answers to common questions about how retirement plans and asset managers are financing deforestation and the climate crisis.'
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'issue-faqs-item' },
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.routes.faqs + '#do-i-have-to-sacrifice-returns-in-order-to-invest-sustainably-',
                          title: 'Do I have to sacrifice returns in order to invest sustainably?',
                          xstrong: true
                        },
                        'Do I have to sacrifice returns in order to invest sustainably?'
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'issue-faqs-item' },
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.routes.faqs + '#why-should-retirement-plans-add-a-sustainable-investment-option-',
                          title: 'Why should retirement plans add a sustainable investment option?',
                          xstrong: true
                        },
                        'Why should retirement plans add a sustainable investment option?'
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'issue-faqs-link' },
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.routes.faqs,
                          title: 'FAQs',
                          xstrong: true
                        },
                        'View all >>'
                      )
                    )
                  )
                )
              )
            ),
            _react2.default.createElement('br', null),
            _react2.default.createElement('br', null)
          )
        )
      );
    }
  }]);
  return IssueDeforestation;
}(_react.Component)) || _class);
exports.default = IssueDeforestation;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/IssuePage/IssueDeforestation.js
// module id = 1482
// module chunks = 0